import {useCallback} from 'react';
import {useHistory} from 'react-router-dom';
import {logPageView, logViewItem} from '../services/googleAnalytics';

/**
 * Custom hook for mapping product data to ProductCard props
 * Standardizes product card prop structure across the application
 */
export const useProductCardProps = () => {
	const history = useHistory();

	// Handle product click
	const handleProductClick = useCallback((refId) => {
		logPageView(`/product/${refId}`);
		logViewItem({}, `/product/${refId}`);
		history.push(`/product/${refId}`);
		window.scrollTo(0, 0);
	}, [history]);

	// Handle cart click
	const handleCartClick = useCallback(() => {
		const joinBtn = document.getElementById('joinBTn');
		if (joinBtn) {
			joinBtn.click();
			window.trigger = 'add to cart';
		}
	}, []);

	// Map product data to card props
	const mapProductToCardProps = useCallback((product) => {
		console.log(product)
		const discountPercent = product.originalPrice > 0 && product.price < product.originalPrice
			? Math.round(((product.originalPrice - product.price) / product.originalPrice) * 100)
			: 0;

		const salePrice = product.originalPrice > 0 ? product.originalPrice : product.price;

		return {
			title: product.name || '',
			image: product.imageResized || product.image || '',
			weight: product.weight || '',
			salePrice,
			discountInPercent: product.discountPercent || discountPercent,
			data: {
				item_id: product.id,
				...product,
				is_shop_open: product.shopOpen,
				country: product.country,
				countries: product.country ? [product.country] : [],
			},
			brand: product.brand,
			outOfStock: !product.inStock,
			promo: product.isPromo ? 1 : 0,
			promoPrice: product.isPromo ? product.price : 0,
			promoStartDate: null,
			promoEndDate: null,
			productCode: product.barCode || product.refId || product.id?.toString() || '',
			isSameDay: product.sameDayDelivery && product.inStock,
			shopOpen: product.shopOpen,
			availableTomorrow: product.availableTomorrow,
			isFavorite: product.isFavorite || 0,
			description: product.description || '',
			onClick: () => handleProductClick(product.refId),
			onCartClick: handleCartClick,
		};
	}, [handleProductClick, handleCartClick]);

	return {mapProductToCardProps};
};
